export const myRfqDrafts = [
  {
    id: "RFQ-2026-001",
    title: "大批量采购不锈钢保温杯",
    category: "家居用品",
    quantity: "5000件",
    unit: "件",
    targetPrice: "¥28–35/件",
    deadline: "2026-05-15",
    status: "已发布",
    responses: 0,
    createdAt: "2026-04-08",
    description: "需要采购不锈钢真空保温杯，容量500ml，需要自有品牌定制，要求通过SGS质检，提供样品。",
    specs: ["容量：500ml", "材质：304不锈钢", "颜色：哑光黑/银色/白色", "需要定制LOGO", "需SGS质检报告"],
    shippingPort: "广州港",
    paymentTerms: "30% 定金，70% 见提单",
  },
  {
    id: "RFQ-2026-002",
    title: "户外运动背包大批量采购",
    category: "运动户外",
    quantity: "2000件",
    unit: "件",
    targetPrice: "¥45–60/件",
    deadline: "2026-05-20",
    status: "草稿",
    responses: 0,
    createdAt: "2026-04-10",
    description: "采购户外登山背包，容量30L，需防水面料，自有品牌定制。",
    specs: ["容量：30L", "材质：防水尼龙", "颜色：军绿/黑色/橙色", "需定制品牌标签"],
    shippingPort: "上海港",
    paymentTerms: "信用证 L/C",
  },
];

export const rfqCategories = [
  "手机数码", "家用电器", "美妆护肤", "服装鞋包",
  "运动户外", "食品生鲜", "家居用品", "母婴玩具",
  "汽车配件", "工业原料", "建筑材料", "农产品", "其他",
];

export const paymentTermOptions = [
  "30% 定金，70% 见提单",
  "信用证 L/C",
  "电汇 T/T",
  "货到付款",
  "分期付款",
  "平台托管付款",
];

export const shippingPorts = [
  "广州港", "上海港", "深圳港", "宁波港", "天津港",
  "青岛港", "厦门港", "大连港", "FOB 工厂", "其他",
];
